<template>
  <div class='box'>
    <div class="no-data-wrap" v-if="!classes || classes.length == 0">
      <img src="../../assets/live/no_data.png" />
    </div>
    <div class="class-warp"  v-for='item in classes' :key='item.class_id'>
      <div  class="class-item" >
        <div class="left">
          <span class="title">{{item.class_name}}
          </span>
          <span class="time">{{item.end}}/{{item.total}}
          </span>
        </div>
        <div class="right">
          <enter-course-btn class="enter-btn" @click="enterClick(item)"></enter-course-btn>
          <!-- <img src='@/assets/live/course_icon.png' class="enter-btn" @click="enterClick(item)"/> -->
        </div>
      </div>
      <div class="line"></div>
    </div>
  </div>
</template>

<script>
import enterCourseBtn from './button/entercourse_btn.vue'
export default {
  name: 'CourseList',
  components:{
    enterCourseBtn
  },
  props: {
    usertype: {
      type: Number,
      default: 1
    },
    classes: {
      type: Array
    }
  },
  data () {
    return {
    }
  },
  created () {
  },
  methods: {
    enterClick (classItem) {
      this.$emit('itemClick', classItem)
    }
  }
}
</script>

<style scoped>

.box {
  height: 100%;
  min-height: 750px;
  display: flex;
  flex-direction: column;
}

.class-warp{

}
.class-item{
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin: 20px 0 20px 0;

}

.left{
   display: flex;
   flex-direction: column;
   align-items: flex-start;
}

.title{
  color: #666666;
  font-size: 18px;
}

.time{
  color: #9B9B9B;
  font-size: 14px;
  margin-top: 5px;
}

.line{
  height: 1px;
  width: 100%;
  border-bottom: 1px solid #cccccc;
}

.enter-btn{
  cursor: pointer;
}

.no-data-wrap{
  width: 100%;
  height: 400px;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/components/live/CourseList.vue